import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=1722c4ba"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1722c4ba')) {
      api.createRecord('1722c4ba', component.options)
    } else {
      api.reload('1722c4ba', component.options)
    }
    module.hot.accept("./Maintenance.vue?vue&type=template&id=1722c4ba", function () {
      api.rerender('1722c4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/maintenance/Maintenance.vue"
export default component.exports